export const SERVICE_OPTIONS = [
  "Mobile Auto Repair",
  "Diagnostics",
  "Electrical",
  "Brakes & Suspension",
  "Pre-Purchase Inspection",
  "Oil Change/Tune-Up",
  "Transmission",
  "Heating & AC",
  "Roadside Assistance",
  "Towing & Transportation",
  "Engine Replacement",
  "Performance Parts",
  "Fleet Service",
  "Other",
] as const;

export type ServiceOption = (typeof SERVICE_OPTIONS)[number];

export type ServiceRequestInput = {
  name: string;
  phone: string;
  email: string;
  vehicle: string;
  service: string;
  location: string;
  message: string;
};

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE = /^[0-9+().\-\s]+$/;

/** Field checks for the request form. The server schema is the source of truth. */
export function validateServiceRequest(
  raw: Record<string, string>,
): { ok: true; data: ServiceRequestInput } | { ok: false; errors: Record<string, string> } {
  const name = (raw["name"] ?? "").trim();
  const phone = (raw["phone"] ?? "").trim();
  const email = (raw["email"] ?? "").trim();
  const vehicle = (raw["vehicle"] ?? "").trim();
  const service = (raw["service"] ?? "").trim();
  const location = (raw["location"] ?? "").trim();
  const message = (raw["message"] ?? "").trim();
  const errors: Record<string, string> = {};

  if (!name || name.length > 100) errors["name"] = "Name is required";
  if (phone.length < 7 || phone.length > 30 || !PHONE.test(phone)) errors["phone"] = "Enter a valid phone number";
  if (email.length > 255 || (email && !EMAIL.test(email))) errors["email"] = "Enter a valid email";
  if (vehicle.length > 120) errors["vehicle"] = "Enter a shorter vehicle description";
  if (service && !SERVICE_OPTIONS.includes(service as ServiceOption)) errors["service"] = "Choose a listed service";
  if (location.length > 120) errors["location"] = "Enter a shorter location";
  if (message.length > 2000) errors["message"] = "Enter a shorter message";

  if (Object.keys(errors).length) return { ok: false, errors };
  return { ok: true, data: { name, phone, email, vehicle, service, location, message } };
}
